import {
  Autocomplete,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { AlenDevice } from "src/interfaces/IAlenDevice";
import { WYND_WHITE } from "src/styles";
import { DeleteOutline } from "@mui/icons-material";
import { ScheduleTargetLevel } from "../types";

export const SCHEDULING_TARGET_LEVELS = [
  { label: "All Devices", value: ScheduleTargetLevel.PROPERTY },
  { label: "Device Models", value: ScheduleTargetLevel.DEVICE_TYPE },
  { label: "Individual Device", value: ScheduleTargetLevel.DEVICE },
];

const DeviceSelection = ({
  options,
  onChange,
  selected,
}: {
  options: AlenDevice[];
  onChange: (deviceIds: string[]) => void;
  selected: string[];
}) => {
  const addDeviceToSelected = (deviceId: string) => {
    onChange([...selected, deviceId]);
  };
  return (
    <Stack>
      <Typography variant="subtitle3" sx={{ marginBottom: "4px" }}>
        Devices
      </Typography>
      <Autocomplete
        value={null}
        sx={{ width: 200, flex: 1 }}
        options={options
          .filter((device) => !selected.includes(device.id))
          .map((device) => device.id)}
        onChange={(_, value) => value !== null && addDeviceToSelected(value)}
        getOptionLabel={(deviceId) =>
          options.find((d) => d.id === deviceId)?.name || ""
        }
        clearOnBlur
        blurOnSelect
        clearOnEscape
        renderInput={(params) =>
          React.createElement(TextField, {
            ...params,
            placeholder: "Device Name",
            size: "small",
            sx: {
              height: "100%",
              ".MuiInputBase-root": { height: "100%" },
            },
          })
        }
      />
    </Stack>
  );
};

export const SelectedDeviceList = ({
  selected,
  onDelete,
}: {
  selected: AlenDevice[];
  onDelete: (deviceId: string) => void;
}) => (
  <Stack direction="row" gap="1rem" flexWrap="wrap">
    {selected.map((device) => (
      <Stack
        key={device.id}
        direction="row"
        alignItems="center"
        sx={{
          backgroundColor: WYND_WHITE,
          paddingLeft: "1rem",
          borderRadius: "2rem",
        }}
      >
        <Typography>{device.name}</Typography>
        <IconButton onClick={() => onDelete(device.id)}>
          <DeleteOutline fontSize="small" color="error" />
        </IconButton>
      </Stack>
    ))}
  </Stack>
);

export default DeviceSelection;
